/**
 * TradeHistory 헬퍼 컴포넌트
 */
import React from 'react';
import TimeDisplay from './TimeDisplay';

type FilterType = 'ALL' | 'TAKE_PROFIT' | 'STOP_LOSS' | 'STRATEGY_SELL';

interface Trade {
  id: number;
  trade_type: 'TAKE_PROFIT' | 'STOP_LOSS' | 'STRATEGY_SELL';
  symbol: string;
  quantity: number;
  profit_percent: number;
  profit_amount: number | null;
  executed_at: string;
}

interface FilterButtonsProps {
  filter: FilterType;
  setFilter: (f: FilterType) => void;
  count?: number;
}

export const FilterButtons: React.FC<FilterButtonsProps> = ({ filter, setFilter, count }) => (
  <div className="filter-buttons">
    <button className={filter === 'ALL' ? 'active' : ''} onClick={() => setFilter('ALL')}>
      전체{count !== undefined && ` (${count})`}
    </button>
    <button className={filter === 'TAKE_PROFIT' ? 'active' : ''} onClick={() => setFilter('TAKE_PROFIT')}>
      수익 실현
    </button>
    <button className={filter === 'STOP_LOSS' ? 'active' : ''} onClick={() => setFilter('STOP_LOSS')}>
      손절
    </button>
    <button className={filter === 'STRATEGY_SELL' ? 'active' : ''} onClick={() => setFilter('STRATEGY_SELL')}>
      전략 매도
    </button>
  </div>
);

interface TradeRowProps {
  trade: Trade;
}

export const TradeRow: React.FC<TradeRowProps> = ({ trade }) => {
  const isProfit = trade.trade_type === 'TAKE_PROFIT';
  const isStrategySell = trade.trade_type === 'STRATEGY_SELL';
  const profitClass = trade.profit_percent >= 0 ? 'profit' : 'loss';

  const typeLabel = isProfit ? '수익 실현' : isStrategySell ? '전략 매도' : '손절';
  const typeClass = isProfit ? 'profit' : isStrategySell ? 'strategy' : 'loss';
  const qty = trade.quantity.toFixed(8).replace(/\.?0+$/, '');

  return (
    <tr>
      <td className="time"><TimeDisplay utcTime={trade.executed_at} /></td>
      <td className="symbol">{trade.symbol}</td>
      <td className={`trade-type align-center ${typeClass}`}>{typeLabel}</td>
      <td className="quantity align-right">{qty}</td>
      <td className={`percent align-right ${profitClass}`}>
        {trade.profit_percent >= 0 ? '+' : ''}{trade.profit_percent.toFixed(2)}%
      </td>
      <td className={`amount align-right ${profitClass}`}>
        {trade.profit_amount !== null && trade.profit_amount !== 0 ? `$${Math.abs(trade.profit_amount).toFixed(2)}` : '-'}
      </td>
    </tr>
  );
};

export type { FilterType, Trade };
